module.exports = __webpack_public_path__ + "static/media/1POLICY25.bd5c2ea6.jpg";